export const teamData = {
  team: [
    {
      name: "Warren Pettine, M.D.",
      title: "Co-founder, CEO",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/6m81jndp_warren.png",
      linkedIn: "https://www.linkedin.com/in/warren-pettine-6aa943202/",
      bio: "15+ years, Health Policy & AI R&D. Asst. Professor, U of Utah"
    },
    {
      name: "Kim Weiss, M.B.A",
      title: "COO",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/zwrp1i3x_kim_mountaineering.jpg",
      linkedIn: "https://www.linkedin.com/in/kimweiss/",
      bio: "20+ years, Health Tech Leadership. CEO Advisor, Early Stage Investor"
    },
    {
      name: "Matthias Christenson, Ph.D.",
      title: "Chief AI Architect",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/9dcpcxzq_matthias%20christensen%20image.jpg",
      linkedIn: "https://www.linkedin.com/in/neuralsignal/",
      bio: "10+ years, Industry & Academia. Adjunct Professor, U of Utah"
    },
    {
      name: "Sow Kobayashi, M.D.",
      title: "Physician Product Lead",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/usad5bdw_sow.png",
      linkedIn: "https://www.linkedin.com/in/sow-kobayashi-18b297193/",
      bio: "10+ years, Healthcare Operations. Chief of EM, Sharp Healthcare"
    },
    {
      name: "Brian Locke, M.D.",
      title: "Medical ML/AI Lead",
      image: "https://customer-assets.emergentagent.com/job_medical-data-flow/artifacts/vowvwpjn_brian%20locke.jpg",
      linkedIn: "https://www.linkedin.com/in/brian-locke-464457155/",
      bio: "ICU Physician. Asst. Professor, Intermountain"
    },
    {
      name: "Kim Weiss, M.B.A",
      title: "COO",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/zwrp1i3x_kim_mountaineering.jpg",
      linkedIn: "https://www.linkedin.com/in/kimweiss/",
      bio: "20+ years, Health Tech Leadership. CEO Advisor, Early Stage Investor"
    }
  ],
  
  advisors: [
    {
      name: "Pranav Koirala, M.D.",
      title: "Co-founder", 
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/bkxzf736_pranav.jpg",
      linkedIn: "https://www.linkedin.com/in/pranawa-koirala-84601397/",
      bio: "EM Physician. Adjunct Professor, U of Maryland"
    },
    {
      name: "Krishna Srihasam, Ph.D.",
      title: "ML Strategy Advisor",
      image: "https://customer-assets.emergentagent.com/job_medical-data-flow/artifacts/bxd5v0td_Krishna%20outdoors.jpg",
      linkedIn: "https://www.linkedin.com/in/krishnasrihasam/",
      bio: "10+ years in Medical AI. Principal AI Architect, Wolters Kluwer Health"
    },
    {
      name: "Charles Kemmler, M.D./Ph.D.",
      title: "Clinical Data Advisor",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/c8nprd7n_charles.jpg",
      linkedIn: "https://www.linkedin.com/in/charles-kemmler-md-phd-b1b9386/",
      bio: "EM Physician. Asst. Professor, University of Pennsylvania"
    },
    // {
    //   name: "Dylan Doty, M.S.",
    //   title: "Government Relations Advisor",
    //   image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/xwv0no40_dylan.jpg",
    //   linkedIn: "https://linkedin.com/in/dylan-doty-ms",
    //   bio: "Army Veteran & West Point. Utah Innovation Center"
    // },
    {
      name: "Allison Long Pettine, M.B.A",
      title: "Strategy Advisor",
      image: "https://customer-assets.emergentagent.com/job_medical-data-flow/artifacts/oxhxhpac_alison.jpg",
      linkedIn: "https://www.linkedin.com/in/alpettine/",
      bio: "20+ years Early-Stage VC. Crescent Ridge Partners"
    },
    {
      name: "Cameron Mullen, B.A",
      title: "Strategy Advisor",
      image: "https://customer-assets.emergentagent.com/job_meddata-fusion/artifacts/rzhd0xic_cameron.jpeg",
      linkedIn: "https://www.linkedin.com/in/mullencam/",
      bio: "10+ years Health Tech Finance. SVP at KX"
    }
  ],
  
  partners: [
    {
      name: "Dr. Jennifer Lee",
      title: "Chief Innovation Officer, Cleveland Clinic",
      image: "https://images.pexels.com/photos/7202817/pexels-photo-7202817.jpeg",
      linkedIn: "https://linkedin.com/in/jennifer-lee-cleveland",
      bio: "Drives innovation strategy for one of America's top hospitals. Champions AI adoption in clinical workflows and patient care optimization."
    },
    {
      name: "Alex Johnson",
      title: "VP of Partnerships, Philips Healthcare",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHN8ZW58MHx8fHwxNzU0MjE2ODI4fDA&ixlib=rb-4.1.0&q=85",
      linkedIn: "https://linkedin.com/in/alex-johnson-philips",
      bio: "Leads strategic partnerships for global medical technology company. Expert in healthcare interoperability and medical device integration."
    },
    {
      name: "Dr. Rachel Green",
      title: "Chief Medical Officer, Kaiser Permanente",
      image: "https://images.pexels.com/photos/19245168/pexels-photo-19245168.jpeg", 
      linkedIn: "https://linkedin.com/in/rachel-green-kaiser",
      bio: "Oversees clinical operations for 12M+ members. Pioneered population health management and predictive analytics in integrated care delivery."
    }
  ]
};